import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAEchq-ZrgjZ7_ADIovDsWXRUYpQNYVVrw",
  authDomain: "latdiagnostics.firebaseapp.com",
  projectId: "latdiagnostics",
  storageBucket: "latdiagnostics.firebasestorage.app",
  messagingSenderId: "33611274224",
  appId: "1:33611274224:web:f695001d1c089c68bb2f35"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
